import { render, staticRenderFns } from "./sellRecord.vue?vue&type=template&id=30128f0d&scoped=true"
import script from "./sellRecord.vue?vue&type=script&lang=js"
export * from "./sellRecord.vue?vue&type=script&lang=js"
import style0 from "./sellRecord.vue?vue&type=style&index=0&id=30128f0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30128f0d",
  null
  
)

export default component.exports